import { useTranslation } from "react-i18next";

import type { NotificationsHeaderProps } from "../../types";
import BaseButton from "@/components_v2/Button/BaseButton";
import { BUTTON_VARIANTS } from "@/components_v2/Button/constants";

const NotificationsHeader = ({
  unreadCount,
  onMarkAllRead,
}: NotificationsHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="notifications-popover-head flex flex-wrap items-center gap-150">
      <div className="flex flex-col flex-grow">
        <span className="notifications-trigger-label body-m-medium">
          {t("notifications.labels.notifications")}
        </span>

        <span className="notifications-popover-new-count body-s-regular">
          {unreadCount > 0
            ? t("notifications.labels.notificationsNewCount", {
                count: unreadCount,
              })
            : t("notifications.labels.notificationsNoNew")}
        </span>
      </div>
      {unreadCount > 0 ? (
        <BaseButton variant={BUTTON_VARIANTS.LINK} onClick={onMarkAllRead}>
          {t("notifications.labels.markAllAsRead")}
        </BaseButton>
      ) : null}
    </div>
  );
};

export default NotificationsHeader;
